import * as yup from "yup";

import { validator as companyDataValidator } from "./CompanyData/validator";
import { validator as contactPersonDataValidator } from "./ContactPersonData/validator";
import { validator as generalDataValidator } from "./GeneralData/validator";
import { validator as personDataValidator } from "./PersonData/validator";

export const validator = yup.object({
  ...generalDataValidator,
  ...personDataValidator,
  ...companyDataValidator,
  ...contactPersonDataValidator,
});
